import React, { useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import useTheme from '@mui/styles/useTheme';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import { useSessionState } from '../../../hooks/useSessionState';
import { DefaultFiltering } from '../../../components/OrdersTable/components/OrderFilters';

function OrdersLink({ statuses, title, total, icon }) {
	const theme = useTheme();
	const [filters, setFilters] = useSessionState(
		'orders_filters',
		DefaultFiltering
	);
	const navigate = useNavigate();
	const ref = useRef(0);

	function handleClick() {
		ref.current += ref.current + 1;
		if (ref.current >= 1) {
			navigate('/orders', {
				state: { isFilterOpen: true },
			});
		}
	}

	return (
		<Grid
			item
			type="button"
			style={{
				textDecoration: 'none',
				textAlign: 'center',
				color:
					statuses.includes('Alert') && total > 0
						? theme.palette.danger.main
						: theme.palette.navy.colorNavy70,
				border: 'none',
				background: 'none',
				cursor: 'pointer',
			}}
			onClick={() => {
				handleClick();
				setFilters({
					status: statuses
						.map((key) => ({ [key]: true }))
						.reduce((a, b) => ({ ...a, ...b })),
				});
			}}
		>
			<Typography variant="heading1">{total || icon}</Typography>
			<Typography
				className="always-underlined"
				style={{ color: '#000000', opacity: '87%' }}
			>
				{title}
			</Typography>
		</Grid>
	);
}

OrdersLink.propTypes = {
	statuses: PropTypes.array,
	icon: PropTypes.object,
	title: PropTypes.string,
	total: PropTypes.string,
};

export default OrdersLink;
